import type { ProviderContext } from 'notistack';
import type { TFunction } from 'i18next';

type HandleApiErrorDeps = {
	t: TFunction;
	enqueueSnackbar: ProviderContext['enqueueSnackbar'];
};

export const handleApiError = (e: any, { t, enqueueSnackbar }: HandleApiErrorDeps) => {
	const notifyApiError = (errorCode: string, errorData?: string) => {
		enqueueSnackbar(t(`api.${errorCode}`, { data: errorData }), {
			variant: 'error',
		});
	};

	const errorCode = e?.response?.status || e?.status || 500;

	if (e?.response?.data?.errors) {
		e.response.data.errors.forEach((error: any) => {
			if (error.code === 'IdentityError') {
				notifyApiError(e.response?.data.data.identityErrorCode);
			} else if (error.code === 'LoginRateLimitExceeded') {
				const secondsToWait = parseInt(error.description);
				notifyApiError(error.code, (secondsToWait / 60).toString());
			} else {
				notifyApiError(error.code);
			}
		});
	} else {
		notifyApiError(String(errorCode), e.response?.data?.data);
	}

	return {
		success: false,
		data: e?.response?.data?.data,
		status: errorCode,
		message: e?.response?.message,
		errors: e?.response?.data?.errors,
	};
};
